import React from "react";
import BeneficiaryTable from "../../BeneficiaryTable/BeneficiaryTable";
import { MdDownload } from "react-icons/md";
import { extractToCSV } from "../utils/fileUtils";

const InvalidRecordsSection = ({
  invalidRecords,
  showInvalidData,
  onToggleShow,
}) => {
  if (!invalidRecords || invalidRecords.length === 0) {
    return null;
  }

  if (!showInvalidData) {
    return (
      <button
        onClick={onToggleShow}
        className="flex items-center mr-4 px-5 py-2.5 rounded-lg font-medium text-amber-800 bg-amber-100 hover:bg-amber-200 transition-colors relative"
      >
        <span className="absolute -top-1 -right-1 flex h-3 w-3">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
        </span>
        Ver {invalidRecords.length} registros com problemas
      </button>
    );
  }

  return (
    <div className="mt-6 mb-6">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-lg font-medium text-gray-700">
          Registros com problemas ({invalidRecords.length})
        </h3>
        <button
          onClick={() => extractToCSV(invalidRecords)}
          className="flex items-center gap-1 bg-gray-200 hover:bg-gray-300 text-gray-700 px-3 py-1 rounded-lg text-sm transition-colors"
        >
          <MdDownload className="text-lg" /> Exportar CSV
        </button>
      </div>
      <div className="bg-red-50 border border-red-200 rounded-lg p-4 mb-3">
        <div className="flex items-start mb-3">
          <div className="text-red-600 mr-2 mt-0.5">⚠️</div>
          <div>
            <p className="text-red-700 font-medium">
              Atenção: estes registros não serão incluídos no sistema!
            </p>
            <p className="text-red-600 text-sm mt-1">
              Os registros listados abaixo apresentam problemas de formato ou
              dados inválidos. Você pode exportá-los, corrigir os erros e enviar
              novamente em um novo arquivo.
            </p>
          </div>
        </div>
        <BeneficiaryTable beneficios={invalidRecords} isLoadingSend={false} />
      </div>
    </div>
  );
};

export default InvalidRecordsSection;
